module.exports = __webpack_public_path__ + "media/thanos_dust_5.eed1dd08.mp3";